import RecommendedAmoutRemarks from "./RecommendedAmoutRemarks";
import SubsidyAmountsRemarks from "./SubsidyAmountsRemarks";

const RemarksView = ({ remarks, documentNames = [] }) => {
  if (!remarks && documentNames.length === 0) return <p>N/A</p>;

  const investemtUpdateStrings = [
    "Total Stamp Duty Paid Per Year updated from",
    "Recommended Investment updated from",
  ];

  let content;

  try {
    const parsed = JSON.parse(remarks);
    content = <SubsidyAmountsRemarks data={parsed} />;
  } catch {
    const parts = remarks?.split("|").map((p) => p.trim()) || [];
    const hasRecommendedUpdate = investemtUpdateStrings.some(
      (str) =>
        remarks?.includes(str) ||
        (remarks?.toLowerCase().includes("total eligible investment -") &&
          parts.length > 1)
    );
    if (hasRecommendedUpdate) {
      content = <RecommendedAmoutRemarks text={remarks} />;
    } else {
      content = <p className="whitespace-pre-line">{remarks}</p>;
    }
  }

  return (
    <div className="space-y-2">
      {content}
      {documentNames.length > 0 && (
        <div className="mt-2">
          <p className="font-semibold text-red-600">
            Incomplete or Pending Documents:
          </p>
          <ul className="list-disc list-inside text-gray-700">
            {documentNames.map((name, idx) => (
              <li key={idx}>{name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RemarksView;
